module.exports = __webpack_public_path__ + "static/media/HouseOf_medium.6dda9b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/HouseOf_medium.png
// module id = 3
// module chunks = 0